import { render } from "./DentureList.vue?vue&type=template&id=6a36754b"
import script from "./DentureList.vue?vue&type=script&lang=js"
export * from "./DentureList.vue?vue&type=script&lang=js"

import "./DentureList.vue?vue&type=style&index=0&id=6a36754b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__